import { jsxs as w, jsx as d } from "react/jsx-runtime";
import { forwardRef as W } from "react";
import e from "styled-components";
import { getFlavorColor as v } from "../../theme/utils/styleUtils.js";
import b from "../FormLabel/FormLabel.js";
import "../LabelTooltip/LabelTooltip.js";
import z from "../LabelTooltip/utils.js";
const f = (t) => t ? `
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      ` : "", S = e.div.withConfig({
  displayName: "Wrapper"
})([
  "width:",
  ";display:flex;position:relative;flex-direction:",
  ";font-size:",
  ";font-weight:",
  ";line-height:1.2em;"
], ({ $fullWidth: t }) => t ? "100%" : "auto", ({ $layout: t }) => t === "horizontal" ? "row" : "column", ({ theme: t, $textSize: o }) => o === "normal" ? t.typography.body200.fontSize : t.typography.body100.fontSize, ({ theme: t }) => t.typography.fontWeightRegular), F = e(b).withConfig({
  displayName: "StyledFormLabel"
})([
  "&&.formLabelRoot{font-size:",
  ";",
  ";margin:0px;}"
], ({ theme: t, $textSize: o }) => o === "normal" ? t.typography.body200.fontSize : t.typography.body100.fontSize, ({ $LabelProps: t }) => f(t == null ? void 0 : t.noWrap)), N = e.div.withConfig({
  displayName: "Value"
})([
  "flex:1;position:relative;text-align:",
  ";color:",
  ";padding:",
  ";white-space:pre-wrap;",
  ";"
], ({ $ValueProps: t }) => (t == null ? void 0 : t.textAlign) || "left", ({ $flavor: t, theme: o }) => v(o, t, o.text.primary), ({ $layout: t, $ValueProps: o }) => (o == null ? void 0 : o.padding) || (t === "horizontal" ? "0px 0px 0px 16px" : "8px 0px 0px 0px"), ({ $ValueProps: t }) => f(t == null ? void 0 : t.noWrap)), C = /* @__PURE__ */ W(({ defaultValue: t = " ", flavor: o = void 0, fullWidth: m = !1, label: y = " ", layout: r = "vertical", value: i = " ", LabelProps: n = {}, textSize: a = "normal", ValueProps: l = {}, tooltip: g = void 0, ...h }, x) => {
  let p = i;
  (i == null || i === "") && (p = t);
  const { noWrap: L, ...c } = n, { noWrap: R, padding: j, textAlign: u, ...s } = l;
  return /* @__PURE__ */ w(S, {
    ref: x,
    $layout: r,
    ...h,
    $fullWidth: m,
    $textSize: a,
    children: [
      /* @__PURE__ */ d(F, {
        $LabelProps: n,
        $textSize: a,
        ...c,
        children: z(y, g)
      }),
      /* @__PURE__ */ d(N, {
        $ValueProps: l,
        $layout: r,
        $flavor: o,
        ...s,
        children: p
      })
    ]
  });
});
C.displayName = "LabelValue";
export {
  C as default
};
